import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28,12V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8V23a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V19a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Zm-4,9H6V10H24V21Z"/><rect x="8" y="12" width="14" height="7"/>';
export var BatteryFullSVG = function BatteryFullSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BatteryFullSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BatteryFullSVG);